export interface Props {
  primary: string;
  secondary: string;
}

export default function AppHeader({ primary, secondary }: Props) {
  return (
    <h2>
      {primary}&nbsp;
      <span className="font-medium text-muted-foreground">
        {secondary}
      </span>
    </h2>
  )
}
